<template>
  <div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else>
      <div v-if="formType !== 'edit'">
        <div>
          <form-accordion :title="$t('common.security.ssh')" :isTitleUpperCase="false" >
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :input-value="currentSSH.pod" isMandatory
                  :inputLabel="$t('common.security.pod_select')" :placeholderValue="$t('common.security.pod_select')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :input-value="currentSSH.name" isMandatory
                  :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
        </div>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('view')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteSSH">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <ssh-form-edit :pod="currentSSH.pod" :password="currentSSH.privateKeyPassword" :id="currentSSH.id" :name="currentSSH.name"></ssh-form-edit>
      </div>
    </div>
  </div>
</template>
<script>

import Spinner from '@/components/common/spinner.vue'
import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import SSHFormEdit from "@/pages/security/SSHFormEdit.vue";

export default {
  name: 'SSHFormGlobal',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'ssh-form-edit': SSHFormEdit

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listCertificateOutGroup () {
      return this.listCertificates.filter(elem => {
        return !elem.inGroup
      })
    },
    listCertificateInGroup () {
      return this.listCertificates.filter(elem => {
        return elem.inGroup
      })
    }
  },
  data: () => {
    return {
      activateSpinner: true,
      currentSSH: {},
      fields: [],
      formType: 'add',
      name: '',
      pageTitle: '',
      listCertificates: [],
      refreshTab: false
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.getSSH()
    this.fields.push({ key: 'name', tdClass: 'text-center '})
  },
  methods: {
    deleteSSH () {
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.ssh_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.firstOn().security.ssh.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.ssh_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/ssh/0'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.ssh_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getSSH (){
      let that = this
      this.$engine.firstOn().security.ssh.fetch({id: this.id})
      .then(resp => {
        let SSHList = {}

        SSHList = resp.data.ssh

        that.updateSSH(SSHList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      this.formType = mode
    },
    updateSSH (SSHList) {
      this.currentSSH = SSHList[0]
    }
  }
}

</script>
